import { render, staticRenderFns } from "./PatientQueries.vue?vue&type=template&id=1dca3abd"
import script from "./PatientQueries.vue?vue&type=script&lang=ts"
export * from "./PatientQueries.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports